import React from "react";
import MainContainer from "../../components/container/MainContainer";

const AccountReport = () => {
  return <MainContainer>AccountReport</MainContainer>;
};

export default AccountReport;
